import BaseService from './BaseService';
import apiClient from '../plugins/axios';

/**
 * Agent Service
 */
class AgentService extends BaseService {
  constructor() {
    super('agent');
  }

  /**
   * Tüm ajanları listele
   * @returns {Promise}
   */
  async getAllAgents() {
    try {
      const response = await apiClient.get('/agent');
      return response.data;
    } catch (error) {
      throw this.handleError(error);
    }
  }

  /**
   * Yeni ajan oluştur
   * @param {Object} agentData - Ajan verileri
   * @returns {Promise}
   */
  async createAgent(agentData) {
    try {
      const response = await apiClient.post('/agent', agentData);
      return response.data;
    } catch (error) {
      throw this.handleError(error);
    }
  }

  /**
   * Ajan detayını getir
   * @param {string} id - Ajan ID'si
   * @returns {Promise}
   */
  async getAgentById(id) {
    try {
      const response = await apiClient.get(`/agent/${id}`);
      return response.data;
    } catch (error) {
      throw this.handleError(error);
    }
  }

  /**
   * Ajanı güncelle
   * @param {string} id - Ajan ID'si
   * @param {Object} agentData - Güncellenecek ajan verileri
   * @returns {Promise}
   */
  async updateAgent(id, agentData) {
    try {
      const response = await apiClient.put(`/agent/${id}`, agentData);
      return response.data;
    } catch (error) {
      throw this.handleError(error);
    }
  }

  /**
   * Ajanı sil
   * @param {string} id - Ajan ID'si
   * @returns {Promise}
   */
  async deleteAgent(id) {
    try {
      const response = await apiClient.delete(`/agent/${id}`);
      return response.data;
    } catch (error) {
      throw this.handleError(error);
    }
  }

  /**
   * Tüm ajan modellerini listele
   * @param {Object} [query] - { source?: 'AGENT' | 'TTS' }
   * @returns {Promise}
   */
  async getAgentModels(query = {}) {
    try {
      const response = await apiClient.get('/agent/model', { params: query });
      return response.data;
    } catch (error) {
      throw this.handleError(error);
    }
  }

  /**
   * Tek agent modeli getir (superuser)
   * @param {string} id
   * @returns {Promise}
   */
  async getAgentModelById(id) {
    try {
      const response = await apiClient.get(`/agent/model/${id}`);
      return response.data;
    } catch (error) {
      throw this.handleError(error);
    }
  }

  /**
   * Agent model oluştur (superuser)
   * @param {Object} body - CreateAgentModelRequest (name, source, external_path, description?, params?)
   * @returns {Promise} data: CreateResponseModel { id }
   */
  async createAgentModel(body) {
    try {
      const response = await apiClient.post('/agent/model', body);
      return response.data;
    } catch (error) {
      throw this.handleError(error);
    }
  }

  /**
   * Agent model güncelle (superuser)
   * @param {string} id
   * @param {Object} body - UpdateAgentModelRequest (external_path required)
   * @returns {Promise}
   */
  async updateAgentModel(id, body) {
    try {
      const response = await apiClient.put(`/agent/model/${id}`, body);
      return response.data;
    } catch (error) {
      throw this.handleError(error);
    }
  }

  /**
   * Agent model sil (superuser)
   * @param {string} id
   * @returns {Promise}
   */
  async deleteAgentModel(id) {
    try {
      const response = await apiClient.delete(`/agent/model/${id}`);
      return response.data;
    } catch (error) {
      throw this.handleError(error);
    }
  }
}

export default new AgentService();
